function getSelected(element: HTMLElement): any[] | undefined {
    if (!(element instanceof HTMLInputElement)) {
        return;
    }

    const list: any[] = [];
    const listInput = document.querySelectorAll<HTMLInputElement>(
        'input[type=checkbox][name=' + element.name + ']:checked',
    );

    for (const itemInput of listInput) {
        list.push(itemInput.value);
    }

    return list;
}

// ----------------------------------------------------------------------------

export default getSelected;
